// NOTE TO MAINTAINER:
// Done this way to allow local dev builds to not fail if messages are not built.

// Normally this rule is great, but we're doing somthing unconventional.
// eslint-disable-next-line import/no-mutable-exports
let Messages;

try {
    Messages = require('../../../../locale/en-min.json');
} catch (e) {
    if (process.env.NODE_ENV === 'production') {
        throw new Error('Unable to load english messages');
    }

    // eslint-disable-next-line no-console
    console.warn('[WARNING] en.json not found - run "npm run langs:build" to create');
    Messages = {};
}

export default Messages;
